import { useState, useEffect } from "react";
import { Menu, X, Heart } from "lucide-react";

const navLinks = [
  { label: "Home", page: "home" },
  { label: "Students", page: "students" },
  { label: "Committee", page: "committee" },
  
  { label: "Events", page: "events" },
  { label: "Contact", page: "contact" },
];

export default function Navbar({ currentPage, onNavigate }) {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handler = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", handler);
    return () => window.removeEventListener("scroll", handler);
  }, []);

  const handleNav = (page) => { onNavigate(page); setOpen(false); };

  return (
    <header style={{
      position: "fixed", top: 0, left: 0, right: 0, zIndex: 1000,
      background: scrolled ? "rgba(27,67,50,0.98)" : "rgba(27,67,50,0.92)",
      backdropFilter: "blur(12px)",
      boxShadow: scrolled ? "0 2px 20px rgba(0,0,0,0.18)" : "none",
      transition: "all 0.3s ease",
      borderBottom: scrolled ? "1px solid rgba(212,160,23,0.2)" : "none",
    }}>
      <div className="container" style={{ display: "flex", alignItems: "center", justifyContent: "space-between", height: 68 }}>
        {/* Logo */}
        <button
  onClick={() => handleNav("home")}
  style={{
    display: "flex",
    alignItems: "center",
    gap: "0.65rem",
    background: "none",
    border: "none",
    cursor: "pointer",
  }}
>
 

  <div style={{ textAlign: "left" }}>
    <div
      style={{
        fontFamily: "var(--font-display)",
        color: "#FFFFFF",
        fontWeight: 700,
        fontSize: "1.2rem",
        lineHeight: 1.1,
      }}
    >
      Birati Child Care Foundation
    </div>

    <div
      style={{
        fontFamily: "var(--font-label)",
        color: "var(--gold)",
        fontSize: "0.8rem",
        letterSpacing: "0.12em",
        textTransform: "uppercase",
      }}
    >
      A NonProfit Organization
    </div>
  </div>
</button>

        {/* Desktop Nav */}
        <nav style={{ display: "flex", gap: "0.25rem", alignItems: "center" }} className="desktop-nav">
          {navLinks.map(link => (
            <button key={link.page} onClick={() => handleNav(link.page)} style={{
              background: "none", border: "none", cursor: "pointer",
              padding: "0.45rem 0.85rem", borderRadius: 50,
              fontFamily: "var(--font-label)", fontWeight: 600,
              fontSize: "0.88rem", letterSpacing: "0.03em",
              color: currentPage === link.page ? "var(--gold)" : "rgba(255,255,255,0.82)",
              background: currentPage === link.page ? "rgba(212,160,23,0.12)" : "transparent",
              transition: "all 0.18s",
            }}
              onMouseEnter={e => { if (currentPage !== link.page) e.target.style.color = "#fff"; }}
              onMouseLeave={e => { if (currentPage !== link.page) e.target.style.color = "rgba(255,255,255,0.82)"; }}
            >
              {link.label}
            </button>
          ))}
          <button onClick={() => handleNav("contact")} className="btn btn-primary" style={{ marginLeft: "0.5rem", padding: "0.5rem 1.2rem", fontSize: "0.85rem" }}>
            Join Now
          </button>
        </nav>

        {/* Mobile Hamburger */}
        <button onClick={() => setOpen(!open)} style={{ display: "none", color: "#fff", background: "none", border: "none", cursor: "pointer" }} className="hamburger">
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {/* Mobile Menu */}
      {open && (
        <div style={{
          background: "rgba(27,67,50,0.99)", borderTop: "1px solid rgba(212,160,23,0.2)",
          padding: "1rem 0 1.5rem",
        }}>
          {navLinks.map(link => (
            <button key={link.page} onClick={() => handleNav(link.page)} style={{
              display: "block", width: "100%", textAlign: "left",
              padding: "0.75rem 1.5rem", background: "none", border: "none", cursor: "pointer",
              fontFamily: "var(--font-label)", fontWeight: 600, fontSize: "1rem",
              color: currentPage === link.page ? "var(--gold)" : "rgba(255,255,255,0.85)",
              borderLeft: currentPage === link.page ? "3px solid var(--gold)" : "3px solid transparent",
            }}>
              {link.label}
            </button>
          ))}
          <div style={{ padding: "0.75rem 1.5rem" }}>
            <button className="btn btn-primary" style={{ width: "100%" }}>Donate Now</button>
          </div>
        </div>
      )}

      <style>{`
        @media (max-width: 900px) { .desktop-nav { display: none !important; } .hamburger { display: block !important; } }
      `}</style>
    </header>
  );
}
